import { render, staticRenderFns } from "./HolidayPromo.vue?vue&type=template&id=39e0957d&scoped=true&"
import script from "./HolidayPromo.vue?vue&type=script&lang=js&"
export * from "./HolidayPromo.vue?vue&type=script&lang=js&"
import style0 from "./HolidayPromo.vue?vue&type=style&index=0&id=39e0957d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e0957d",
  null
  
)

export default component.exports